import OwnersDetailScreen from "./ownersDetailScreen"
import OwnersListingScreen from "./ownersListingScreen"

const OwnerManagement = {
    OwnersDetailScreen: OwnersDetailScreen,
    OwnersListingScreen: OwnersListingScreen,
}

export default OwnerManagement